import http from './axios'

// 查询列表
const queryPage = ({
    channel,
    pageNo,
    pageSize,
    startDate,
    endDate,
}) => {
    return http.get('/manager/dailyReport/dailyReport', {
        channel,
        pageNo,
        pageSize,
        startDate,
        endDate,
    })
}


// 查询成单列表
const channelPlatformDailyReport = ({
    channel,
    date
}) => {
    return http.get('/manager/dailyReport/channelPlatformDailyReport', {
        channel,
        date
    })
}

export default {
    queryPage,
    channelPlatformDailyReport
}